import { CrudService } from './CrudService';
import { resources } from '../resources';
import { CertificateQueryParams } from '../params/CertificateQueryParams';
import { CertificateDto } from '../models/suppliers/CertificateDto';

export class CertificateService extends CrudService<CertificateDto, CertificateQueryParams> {
  constructor() {
    super({
      query: resources.queryCertificates,
      create: resources.createCertificate,
      update: resources.updateCertificate,
      get: resources.getCertificate,
      idKey: 'certificateId',
    });
  }
}
